import * as React from 'react';

export function NotFound(): React.ReactElement {
  return <>not found</>;
}
